<template>
  <div class="main-top">
    <div id="breadcrumb">
      <ol>
        <li>
          <a href="" @click.prevent="transitionToMainMenu()">
            {{ $t("KYG000000.label.breadcrumb_topmenu") }}</a
          >
        </li>
        <li
          v-for="(breadcrumb, idx) in breadcrumbList"
          :key="idx"
          :aria-current="{ page: !!breadcrumb.link }"
        >
          <span
            aria-current="page"
            v-if="breadcrumb.link === $router.currentRoute.path"
          >
            {{ $t(breadcrumb.name) }}
          </span>
          <a
            href=""
            @click.prevent="
              transitionToScreen($t(breadcrumb.message), breadcrumb.link)
            "
            v-else
          >
            {{ $t(breadcrumb.name) }}</a
          >
        </li>
      </ol>
      <!-- /#breadcrumb -->
    </div>
    <div class="user">
      <p class="ta-r">
        <b>{{ userInfo }}</b>
        <br />{{ lastloginDate }}
      </p>
    </div>
    <p class="link-btn-01 icn-01">
      <a href="" @click.prevent="logOut()">
        <span>ログアウト</span>
      </a>
    </p>
    <!-- /.main-top -->
  </div>
</template>

<script>
import url from "@/constants/url-const";
import EventLogService from "@/core/utils/event-log-service";
import logoutService from "@/core/utils/logout-service";
import CommonService from "@/core/utils/common-service";

export default {
  name: "PageMainTop",
  data() {
    return {
      userInfo: "",
      lastloginDate: "",
      breadcrumbList: []
    };
  },
  mounted: function() {
    this.getAuthenticatedUser();
    this.updateList();
  },
  watch: {
    $route() {
      const currentBreadcrumb = this.$route.meta.breadcrumb;
      if (currentBreadcrumb) {
        const breadcrumbId = this.$store.getters.commonInfo.breadcrumbId;
        if (breadcrumbId || breadcrumbId === 0) {
          this.breadcrumbList = currentBreadcrumb[breadcrumbId];
        } else {
          this.breadcrumbList = currentBreadcrumb;
        }
      }

      const currentBreadcrumbParam = this.$route.meta.breadcrumbParam;
      if (currentBreadcrumbParam && this.$route.params.hasBreadcrumbParam) {
        this.breadcrumbList = currentBreadcrumbParam;
      }
    }
  },
  methods: {
    logOut: function() {
      CommonService.showDialogConfirm(
        this.$bvModal,
        this.$createElement,
        this.$t("Message.logout_confirm")
      ).then(isLogout => {
        if (isLogout) {
          /*EventLogService.writeLog(
            "1",
            "画面共通レイアウト",
            "ワールドポータル利用終了",
            1,
            "KYG000000"
          );*/
          logoutService.postLogout();
          location.href = url.LINK_YMT_YBM_LOGIN;
        }
      });
    },
    async getAuthenticatedUser() {
      const authenticatedUser = this.$store.getters.authenticatedUser;

      this.userInfo = this.$t("KYG000000.label.header_mister", {
        0: authenticatedUser.customerName,
        1: authenticatedUser.loginUserName
      });

      if (
        authenticatedUser.lastloginDate === undefined ||
        authenticatedUser.lastloginDate === null
      ) {
        this.lastloginDate = this.$t("KYG000000.label.header_last_logon") + ":";
      } else {
        this.lastloginDate =
          this.$t("KYG000000.label.header_last_logon") +
          ": " +
          authenticatedUser.lastloginDate;
      }
    },
    updateList() {
      this.breadcrumbList = this.$route.meta.breadcrumb;
    },
    transitionToMainMenu() {
      CommonService.showDialogConfirm(
        this.$bvModal,
        this.$createElement,
        this.$t("Message.BackConfirm", {
          0: this.$t("KYG000000.label.breadcrumb_topmenu")
        })
      ).then(isBackToMainMenu => {
        if (isBackToMainMenu) {
          location.href = url.LINK_YMT_YBM_MAIN_MENU;
        }
      });
    },
    transitionToScreen(breadcrumbMessage, breadcrumbLink) {
      CommonService.showDialogConfirm(
        this.$bvModal,
        this.$createElement,
        this.$t("Message.BackConfirm", {
          0: breadcrumbMessage
        })
      ).then(isBackToScreen => {
        if (isBackToScreen) {
          this.$router.push({
            path: breadcrumbLink
          });
        }
      });
    }
  }
};
</script>
